import { useState } from "react";
import { X, Loader2, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

const field = "w-full rounded-lg bg-white/5 border border-white/10 px-3 py-2 text-sm text-white placeholder:text-white/40 outline-none focus:border-white/30";

export function PrayerForm({ streamId, sessionId, defaultName, accent, onClose }) {
  const [f, setF] = useState({ name: defaultName || "", request: "", contact: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post(`/public/streams/${streamId}/prayer`, { session_id: sessionId, ...f });
      setDone(true);
    } catch (e2) { setErr(e2?.response?.data?.detail || "Couldn't send your request"); } finally { setBusy(false); }
  };

  return (
    <div data-testid="prayer-form-panel" className="absolute inset-0 z-20 bg-[#0d1017]/95 backdrop-blur p-4 flex flex-col animate-in fade-in duration-200">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-semibold text-white">Prayer request</p>
        <button data-testid="prayer-close" onClick={onClose} className="h-7 w-7 rounded-md text-white/60 hover:text-white flex items-center justify-center"><X className="h-4 w-4" /></button>
      </div>
      {done ? (
        <div data-testid="prayer-success" className="flex-1 flex flex-col items-center justify-center text-center gap-2">
          <CheckCircle2 className="h-8 w-8" style={{ color: accent }} />
          <p className="text-sm text-white">Thank you. Our team will be praying for you.</p>
          <button data-testid="prayer-done" onClick={onClose} className="mt-2 text-xs text-white/60 hover:text-white">Back to chat</button>
        </div>
      ) : (
        <form onSubmit={submit} className="flex-1 min-h-0 flex flex-col gap-2">
          <p className="text-[11px] text-white/50">Sent privately to the church team — not shown in chat.</p>
          <input data-testid="prayer-name-input" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} maxLength={40} placeholder="Your name" className={field} required />
          <textarea data-testid="prayer-request-input" value={f.request} onChange={(e) => setF({ ...f, request: e.target.value })} maxLength={1000} placeholder="How can we pray for you?" className={field + " min-h-[80px] h-32 max-h-48 resize-none"} required />
          <input data-testid="prayer-contact-input" value={f.contact} onChange={(e) => setF({ ...f, contact: e.target.value })} maxLength={120} placeholder="Email or phone for follow-up (optional)" className={field} />
          {err && <p data-testid="prayer-error" className="text-[11px] text-red-300">{err}</p>}
          <button data-testid="prayer-submit" type="submit" disabled={busy || !f.name.trim() || !f.request.trim()} className="rounded-lg py-2 text-sm font-semibold text-black disabled:opacity-50 flex items-center justify-center gap-2" style={{ background: accent }}>
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Send request
          </button>
        </form>
      )}
    </div>
  );
}
